import React, { useEffect, useState } from "react";
import { Col, Form, Row, Spinner } from "react-bootstrap";
import { FaCircleXmark } from "react-icons/fa6";
import { Button, Input } from "../CustomComponents";
import ModalContainer from "../ModalContainer";
import cssStyles from "./styles/editModal.module.scss";
import _ from "lodash";
import Toast, { SuccessToast } from "../../Hooks/useToast";
import {
  useAddServiceMutation,
  useUpdateServiceMutation,
} from "../../Data/services/serviceApi";
import { Controller, useForm } from "react-hook-form";
import { useUploadAttachmentMutation } from "../../Data/services/uploadAttachmentApi";
import {
  useAddPackageMutation,
  useUpdatePackageMutation,
} from "../../Data/services/packageApi";

const EditPackageModal = ({ handleEditModalClose, editData, refetch }) => {
  const {
    handleSubmit,
    control,
    formState: { errors },
    setValue,
  } = useForm({});
  const [rowId, setRowId] = useState("");
  const [sending, setSending] = useState(false);
  const [imageUrl, setImageUrl] = useState("");

  const [mounted, setMounted] = React.useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    if (editData) {
      setRowId(editData.id);
      setValue("name", editData.name);
      setValue("quantity", editData.quantity);
      setValue("price", editData.price);
      setImageUrl(editData.image);
    }
  }, [editData, mounted]);

  const [uploadAttachment, { isLoading: isUploading }] =
    useUploadAttachmentMutation();

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const formData = new FormData();
    formData.append("file", file);
    formData.append("path", "admin");

    // Loop through formData
    for (let [key, value] of formData.entries()) {
      console.log(key, value);
    }

    try {
      const response = await uploadAttachment({ formData }).unwrap();
      console.log(response);

      // const result = await response.json();
      setImageUrl(response.data[0]); // e.g., "category/1741589867693.png"
      // // setImageFile(file);
      // SuccessToast("Image uploaded successfully");
    } catch (error) {
      Toast("Failed to upload image", "error");
    } finally {
      // setUploadingImage(false);
    }
  };

  const [addPackage, { isLoading: adding }] = useAddPackageMutation();
  const [updatePackage, { isLoading: updating }] = useUpdatePackageMutation();

  const handleSave = async (data) => {
    console.log(rowId);
    data.image = imageUrl;
    console.log(data);

    setSending(true);
    try {
      let response;
      if (editData) {
        response = await updatePackage({ data, id: rowId }).unwrap();
      } else {
        response = await addPackage(data).unwrap();
      }

      console.log(response);

      if (response.code === 200) {
        refetch();
        setSending(false);
        SuccessToast(response?.message);
        handleEditModalClose();
      }
    } catch (error) {
      console.log(error);
      if (error?.response && error?.response?.data?.message) {
        Toast(error?.response?.data?.message, "error");
      } else {
        Toast("An error occurred during login", "error");
      }
      handleEditModalClose();
      setSending(false);
    }
  };

  if (!mounted) {
    return;
  }

  return (
    <div>
      <ModalContainer handleClose={handleEditModalClose}>
        <div className={cssStyles.modalContainer}>
          <div className="d-flex align-items-center w-100 justify-content-between mb-4">
            <p className="fs-4 fw-medium m-0 text-black">
              {editData ? "Edit Package" : "Add Package"}
            </p>
            <span className="bg-dark bg-opacity-75 d-flex p-3 rounded-5">
              <FaCircleXmark
                role="button"
                onClick={handleEditModalClose}
                style={{ cursor: "pointer" }}
              />
            </span>
          </div>
          <div className="w-100">
            <Form onSubmit={handleSubmit(handleSave)}>
              <Row>
                <Col md={12}>
                  <div className="d-flex justify-content-between">
                    <p className="m-0 text-black">Name</p>
                    {errors?.name?.message ? (
                      <p className="m-0 text-danger text-center">
                        {errors?.name?.message}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <Controller
                    control={control}
                    name="name"
                    // defaultValue={""}
                    rules={{
                      required: "Name is required.",
                    }}
                    render={({ field: { onChange, onBlur, value, ref } }) => (
                      <Input
                        classes="mt-2 mb-3"
                        type="text"
                        placeholder="Enter name"
                        value={value}
                        onChange={onChange}
                      />
                    )}
                  />
                </Col>
              </Row>

              <Row>
                <Col md={12}>
                  <div className="d-flex justify-content-between">
                    <p className="m-0 text-black">Quantity</p>
                    {errors?.quantity?.message ? (
                      <p className="m-0 text-danger text-center">
                        {errors?.quantity?.message}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <Controller
                    control={control}
                    name="quantity"
                    // defaultValue={""}
                    // rules={{
                    //   required: " is required.",
                    // }}
                    render={({ field: { onChange, onBlur, value, ref } }) => (
                      <Input
                        classes="mt-2 mb-3"
                        type="number"
                        placeholder="Enter quantity"
                        value={value}
                        onChange={onChange}
                      />
                    )}
                  />
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <div className="d-flex justify-content-between">
                    <p className="m-0 text-black">Price</p>
                    {errors?.price?.message ? (
                      <p className="m-0 text-danger text-center">
                        {errors?.price?.message}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <Controller
                    control={control}
                    name="price"
                    // defaultValue={""}
                    // rules={{
                    //   required: " is required.",
                    // }}
                    render={({ field: { onChange, onBlur, value, ref } }) => (
                      <Input
                        classes="mt-2 mb-3"
                        type="number"
                        placeholder="Enter price"
                        value={value}
                        onChange={onChange}
                      />
                    )}
                  />
                </Col>
              </Row>

              <Row>
                <Col md={12}>
                  <p className="m-0 text-black">Image</p>
                  <Input
                    classes="mt-2 mb-3"
                    type="file"
                    placeholder="Image"
                    onChange={(e) => {
                      handleImageUpload(e);
                    }}
                  />
                </Col>
              </Row>

              <Row className="w-100 text-center">
                <Col md={12}>
                  <img
                    src={imageUrl || "https://placehold.co/100x100"}
                    alt="category_image"
                    width={100}
                    height={100}
                    className="rounded"
                  />
                </Col>
              </Row>

              <Row>
                <Col md={12}>
                  <Button
                    classes={`${cssStyles.cardBtn} mt-4 `}
                    text={
                      sending ? (
                        <Spinner
                          animation="grow"
                          size="sm"
                          className="mx-3 my-1"
                        />
                      ) : editData ? (
                        "Update"
                      ) : (
                        "Save"
                      )
                    }
                    onClick={handleSubmit}
                  ></Button>
                </Col>
              </Row>
            </Form>
          </div>
        </div>
      </ModalContainer>
    </div>
  );
};

export default EditPackageModal;
